<style scoped>
.videoBox {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 300px;
    height: 170px;
    z-index: 3;
}
.videoClose {
    position: absolute;
    top: -15px;
    right: 0;
    display: block;
    width: 15px;
    height: 15px;
    background-image: url(../assets/images/videoClose.png);
    background-size: 100% 100%;
}
video {
    outline: none;
    width: 100%;
    height: 100%;
}
</style>
<template>
    <div class="videoBox" v-if="showVideoBox">
        <video id="videoDOM" controls="controls" autoplay src="@/assets/images/bannerVideoNew2.mp4" type="video/mp4"></video>
        <a class="videoClose" @click="videoClose"></a>
    </div>
</template>
<script>
export default {
    name: 'videoBox',
    data () {
        return {
            showVideoBox: true
        }
    },
    methods: {
        videoClose() {
            this.showVideoBox = false;
            const videoDOM = document.getElementById('videoDOM');
            videoDOM.pause();
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/videoBox.vue